import { render, staticRenderFns } from "./GasStationCreate.vue?vue&type=template&id=45d28d0a"
import script from "./GasStationCreate.vue?vue&type=script&lang=js"
export * from "./GasStationCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports